export { TASK, SAGA_ACTION, noop, is, deferred, arrayOfDeffered, createMockTask, cloneableGenerator } from './internal/utils';
export { asEffect } from './internal/io';
export { CHANNEL_END } from './internal/proc';


//////////////////
// WEBPACK FOOTER
// ./~/redux-saga/es/utils.js
// module id = 1099
// module chunks = 4